<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-email-audit-presenter
    [items]="EmailAuditModel$ | async"
    (DateFiltersChanged)="onDateFiltersChanged($event)"
></ef-email-audit-presenter>
